import { css as _css } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { responsiveWidthType, responsiveHeightType } from "../hooks/useResponsiveProp";
import useResponsivePropsCSS from "../hooks/useResponsivePropsCSS";
import { responsiveSize } from "../utils/css";
import { mergeProps } from "../utils/component";
import Flex from "./Flex";
import Text from "./Text";
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_PROPS = {
  height: "72px",
  label: "Placeholder"
};

function Placeholder(props) {
  var theme = useTheme();
  var mergedProps = mergeProps(props, DEFAULT_PROPS, {}, {
    label: function label(_label) {
      return typeof _label === "string" && _label.trim().length > 0;
    }
  });
  var label = mergedProps.label,
      testId = mergedProps.testId;
  var responsivePropsCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    width: responsiveSize("width"),
    height: responsiveSize("height")
  });
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css(_objectSpread(_objectSpread({}, responsivePropsCSS), {}, {
      backgroundColor: theme.getColor("grey.t07"),
      border: "".concat(theme.borderWidths[1], " solid ").concat(theme.getColor("grey.t30")),
      boxSizing: "border-box"
    }), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    "data-testid": testId
  }, ___EmotionJSX(Flex, {
    height: "100%",
    placeItems: "center"
  }, ___EmotionJSX(Text, null, label)));
}

Placeholder.propTypes = _objectSpread(_objectSpread(_objectSpread({}, responsiveWidthType), responsiveHeightType), {}, {
  label: PropTypes.string,
  testId: PropTypes.string
});
export default Placeholder;